import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { useStore } from "../../stores/rootStore";
import { Modal } from "../ui/Modal";
import { AuthForm } from "./AuthForm";
import { BrandLogo } from "../layout/BrandLogo";

export const AuthModal = observer(() => {
	const { auth, ui } = useStore();
	const { t } = useTranslation();

	useEffect(() => {
		if (!ui.authModalOpen) {
			auth.clearFeedback();
		}
	}, [ui.authModalOpen, auth]);

	useEffect(() => {
		if (ui.authModalOpen && auth.isLoggedIn) {
			ui.closeAuth(true);
		}
	}, [ui, ui.authModalOpen, auth.isLoggedIn]);

	return (
		<Modal
			open={ui.authModalOpen}
			onClose={() => ui.closeAuth()}
			widthClass="max-w-md"
			hideHeader
		>
			<div className="flex items-center justify-between gap-4">
				<BrandLogo />
				<button
					type="button"
					onClick={() => ui.closeAuth()}
					aria-label={t("common.close")}
					className="grid size-9 shrink-0 place-items-center rounded-full text-muted transition hover:bg-surface-2 hover:text-text"
				>
					<X size={22} />
				</button>
			</div>
			<div className="mx-auto mt-8 w-full max-w-md sm:mt-10">
				<AuthForm showLogo={false} />
			</div>
		</Modal>
	);
});
